import api from "@/config/api";
import { Report } from "@/types/report";
import { Params } from "@/types/utils";
import { log } from "@/utils/logger";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

const useQueryReport = () => {
    const { oid, sid, rid } = useParams<Params>();
    const enabled = !!(oid && sid && rid);

    const getReport = async () => {
        try {
            const data = await api.get<Report>(
                `/organizations/${oid}/submissions/${sid}/reports/${rid}`,
            );
            return data;
        } catch (e) {
            log.error(e);
        }
    };

    return useQuery({
        queryKey: ["report", rid],
        queryFn: getReport,
        enabled,
    });
};

export default useQueryReport;
